export const getRemToPx = (rem = 1) => {
  // Calculate the pixel equivalent for rem.
  return rem * parseFloat(window.getComputedStyle(document.documentElement).fontSize)
}
